module.exports = __webpack_public_path__ + "img/icons B_16.0a608d68.png";